export default {
      id: "linkedin-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }